import styled from "styled-components";
import { NavLink } from "react-router-dom";
import * as StyledTypography from "@/styles/Styled.Typography";
import { fluid } from "@/styles/utils/fluid";

export const FooterLayoutWrapper = styled.footer`
  max-width: 1728px;
  min-width: 360px;
  position: relative;
  margin: ${({ theme }) => `
      0
      ${fluid({
        minSize: theme.spacing.footer.xs,
        maxSize: theme.spacing.footer.xl,
        minVW: theme.breakpointValues.xs,
        maxVW: theme.breakpointValues.xl,
        baseFontMin: theme.baseFont.xs,
        baseFontMax: theme.baseFont.xl,
      })}
    `};
  li {
    padding: 0;
    margin: 0;
  }
`;

export const FooterNavWrapper = styled.nav`
  width: 100%;
  border-top: 1px solid ${({ theme }) => theme.colors.onyx};
  display: flex;
  justify-content: center;
  ul {
    list-style-type: none;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    margin: 0;
    padding: ${({ theme }) => theme.spacing.footer.xs}rem 0;
  }
`;

export const NavLinks = styled(NavLink)`
  display: inline;
  padding-bottom: 4px; /* space for underline */
  text-decoration: none;
  white-space: normal;
  color: ${({ theme }) => theme.colors.onyx};
  background-image: linear-gradient(
    to right,
    ${({ theme }) => theme.colors.imperialRed},
    ${({ theme }) => theme.colors.imperialRed}
  );
  background-size: 0% 2px; /* start with 0 width, 2px tall */
  background-repeat: no-repeat;
  background-position: left bottom; /* stick it to the baseline */
  transition: background-size 0.3s ease, color 0.3s ease;
  &:hover {
    color: ${({ theme }) => theme.colors.imperialRed};
    background-size: 100% 2px; /* animate width across the text */
  }
`;

export const FooterNav = styled(StyledTypography.TypoMenu1)`
  /* text-transform: uppercase; */
  gap: ${({ theme }) => theme.spacing.footer.xs}rem;
  a {
    display: inline;
    padding-bottom: 4px; /* space for underline */
    text-decoration: none;
    white-space: normal;
    color: ${({ theme }) => theme.colors.onyx};
    background-image: linear-gradient(
      to right,
      ${({ theme }) => theme.colors.imperialRed},
      ${({ theme }) => theme.colors.imperialRed}
    );
    background-size: 0% 2px; /* start with 0 width, 2px tall */
    background-repeat: no-repeat;
    background-position: left bottom; /* stick it to the baseline */
    transition: background-size 0.3s ease, color 0.3s ease;
    &:hover {
      color: ${({ theme }) => theme.colors.imperialRed};
      background-size: 100% 2px; /* animate width across the text */
    }
  }
`;

export const UtilityNavWrapper = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.onyx};
  display: flex;
  flex-flow: row nowrap;
  ul {
    list-style-type: none;
    display: flex;
    align-items: baseline;
    margin: 0;
    padding: ${({ theme }) => theme.spacing.footer.xs}rem 0;
    /* xs only */
    @media ${({ theme }) => theme.breakpoints.xs} {
      /* flex-flow: column wrap; */
    }
    /* sm and up */
    @media ${({ theme }) => theme.breakpoints.sm} {
    }
  }
  /* xs only */
  @media ${({ theme }) => theme.breakpoints.xs} {
    flex-direction: column;
    justify-content: center;
  }
  /* sm and up */
  @media ${({ theme }) => theme.breakpoints.sm} {
    flex-direction: column;
    justify-content: center;
  }
  /* sm to md */
  @media ${({ theme }) => theme.breakpoints.md} {
    flex-direction: row;
    justify-content: space-between;
  }
  /* md and up */
  @media ${({ theme }) => theme.breakpoints.lg} {
    flex-direction: row;
    justify-content: space-between;
  }
  /* lg to xl */
  @media ${({ theme }) => theme.breakpoints.xl} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const UtilityNav = styled(StyledTypography.TypoCaption2)`
  gap: ${({ theme }) => theme.fontScale.majorSecond.size}rem;
  align-self: center;
`;

export const SocialNav = styled(StyledTypography.TypoCaption2)`
  gap: ${({ theme }) => theme.fontScale.majorSecond.size}rem;
  align-self: center;
  a {
    display: inline;
    padding-bottom: 4px; /* space for underline */
    text-decoration: none;
    white-space: normal;
    color: ${({ theme }) => theme.colors.onyx};
    background-image: linear-gradient(
      to right,
      ${({ theme }) => theme.colors.imperialRed},
      ${({ theme }) => theme.colors.imperialRed}
    );
    background-size: 0% 2px; /* start with 0 width, 2px tall */
    background-repeat: no-repeat;
    background-position: left bottom; /* stick it to the baseline */
    transition: background-size 0.3s ease, color 0.3s ease;
    &:hover {
      color: ${({ theme }) => theme.colors.imperialRed};
      background-size: 100% 2px; /* animate width across the text */
    }
  }
`;
